import { Allotment } from 'allotment'
import clsx from 'clsx'
import { Outlet, useOutletContext } from 'react-router'
import { useHydrated } from 'remix-utils/use-hydrated'

import { ConsumerSideNavigation } from '~/components/ConsumerSideNavigation'
import { useWindowDimensions } from '~/hooks/useWindowDimensions'

const SIDE_NAV_WIDTH = 250

export const DesktopView = ({ tableOfContents, branding }) => {

  /*
    Because <Allotment /> isn't rendered server side, we have to render it only after page is hydrated,
    otherwise styles won't be loaded and we'll see a few seconds of sidenav with page/api content being stacked together.
  */
  const isHydrated = useHydrated()

  const { width } = useWindowDimensions()
  const maxWidth = width ? width / 3 : 375

  const { isPreview } = useOutletContext<any>()

  const { accentColor, fontName } = branding

  return (
    <div
      data-testid="docs-container"
      className={clsx(
        isPreview ? 'h-[calc(100%_-_120px)]' : 'h-[calc(100%_-_60px)]',
        !isHydrated && 'grid grid-cols-[15.625rem_minmax(0,_1fr)] w-full',
      )}
      style={{ fontFamily: fontName }}
    >
      {isHydrated ? (
        <Allotment className="w-full h-full allotment-overflow-visible"
          defaultSizes={[SIDE_NAV_WIDTH, width - SIDE_NAV_WIDTH]}>
          <Allotment.Pane
            minSize={SIDE_NAV_WIDTH}
            preferredSize={SIDE_NAV_WIDTH}
            maxSize={maxWidth}
            visible={tableOfContents.length > 0}
          >
            <ConsumerSideNavigation
              tableOfContents={tableOfContents}
              accentColor={accentColor}
            />
          </Allotment.Pane>
          <Allotment.Pane>
            <section className="h-full overflow-hidden"><Outlet /></section>
          </Allotment.Pane>
        </Allotment>
      ) : <>
        <nav
          className={clsx(
            'h-full overflow-hidden',
          )}
        >
          <ConsumerSideNavigation
            tableOfContents={tableOfContents}
            accentColor={accentColor}
          />
        </nav>
        <section className={
          clsx('h-full overflow-hidden',
            tableOfContents?.length && 'border-l border-l-neutral-30 dark:border-l-neutral-90',
          )}
        ><Outlet /></section>
      </>}
    </div>
  )
}